import { Link } from 'react-router-dom'
import './journeyIndia.scss'

// Stroke line-icon wrapper (currentColor), matching the hero / route-page art.
const Ic = ({ children }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
)

const Arrow = () => (
  <svg className="ji-arrow" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
)

// Four kinds of journey, not four more benefits (that is the Why-Choose grid's
// job). Each links to a real, high-value page we want crawled and ranked.
const JOURNEYS = [
  {
    title: 'Temple & pilgrimage',
    text: 'Somnath, Dwarka and the Statue of Unity, the roads you take for the ones you love.',
    to: '/cities/somnath/',
    icon: (
      <Ic>
        <path d="M12 2.6l2.4 3.1H9.6L12 2.6Z" />
        <path d="M12 5.7v2.1" />
        <path d="M6.6 21V10.4L12 7.8l5.4 2.6V21" />
        <path d="M4.6 21h14.8" />
        <path d="M10 21v-3.4a2 2 0 0 1 4 0V21" />
      </Ic>
    ),
  },
  {
    title: 'Hills & getaways',
    text: 'Mount Abu, Saputara and Udaipur, the long weekend begins the moment you sit back.',
    to: '/routes/ahmedabad-to-mount-abu-cab/',
    icon: (
      <Ic>
        <path d="M2.5 20h19" />
        <path d="M4 20l5.5-9 3.2 4.4" />
        <path d="M10.5 20l4.2-7 6.3 7" />
        <circle cx="7.2" cy="6.4" r="1.7" />
      </Ic>
    ),
  },
  {
    title: 'City to city',
    text: 'Ahmedabad, Surat, Mumbai and beyond, one honest fixed fare shown before you go.',
    to: '/routes/ahmedabad-to-mumbai-cab/',
    icon: (
      <Ic>
        <circle cx="6" cy="6.2" r="2.1" />
        <circle cx="18" cy="17.8" r="2.1" />
        <path d="M8.1 6.2h4.9a3 3 0 0 1 0 6H9a3 3 0 0 0 0 6h4.9" strokeDasharray="0.5 3.2" />
      </Ic>
    ),
  },
  {
    title: 'Airports & stations',
    text: 'Early flights and late trains, with a driver already waiting when you arrive.',
    to: '/cities/ahmedabad/',
    icon: (
      <Ic>
        <path d="M3 13.4l17.5-6.2a1.1 1.1 0 0 1 1.4 1.4l-6.2 17.5a1.05 1.05 0 0 1-2-0.1l-2.5-7-7-2.5a1.05 1.05 0 0 1-0.2-2Z" />
        <path d="M11.2 12.8l4-4" />
      </Ic>
    ),
  },
]

const JourneyIndia = () => (
  <section className="journey-india" aria-labelledby="journey-india-heading">
    <div className="journey-india__bg" aria-hidden="true">
      <svg viewBox="0 0 1440 560" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="ji-glow" cx="0.85" cy="0.12" r="0.55">
            <stop offset="0" stopColor="#ffd9a8" stopOpacity="0.16" />
            <stop offset="1" stopColor="#ffd9a8" stopOpacity="0" />
          </radialGradient>
        </defs>
        <rect width="1440" height="560" fill="url(#ji-glow)" />

        {/* chakra mandala, a quiet Indian motif turning very slowly */}
        <g className="ji-spin" stroke="#ffd9a8" strokeOpacity="0.22" strokeWidth="2" fill="none">
          <circle cx="1270" cy="120" r="94" />
          <circle cx="1270" cy="120" r="60" />
          <circle cx="1270" cy="120" r="13" />
          <path d="M1364 120 H1176 M1351 166 L1189 74 M1316 199 L1224 41 M1270 214 V26 M1224 199 L1316 41 M1189 166 L1351 74" />
          <circle cx="1364" cy="120" r="3" /><circle cx="1176" cy="120" r="3" />
          <circle cx="1270" cy="214" r="3" /><circle cx="1270" cy="26" r="3" />
        </g>

        {/* soft travelling currents */}
        <g fill="none" stroke="#ffffff" strokeOpacity="0.08" strokeWidth="2">
          <path d="M-40 410 C 320 330 520 470 820 390 S 1300 330 1500 410" />
          <path d="M-40 470 C 320 390 520 530 820 450 S 1300 390 1500 470" />
        </g>

        {/* faint Indian skyline, temple shikhara + domed gate + minaret */}
        <g fill="none" stroke="#ffffff" strokeOpacity="0.1" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round">
          <path d="M150 516 V456 L190 414 L230 456 V516" /><path d="M190 414 V400" />
          <path d="M330 516 V450 Q330 420 364 420 Q398 420 398 450 V516" /><path d="M318 516 H410" /><path d="M364 420 V404" />
          <path d="M540 516 L556 516 L550 424 L546 424 Z" /><path d="M544 470 H552 M545 446 H551" /><path d="M548 424 Q542 412 554 424" />
        </g>

        {/* dashed intercity route threading location pins */}
        <g fill="none" stroke="#ffd9a8" strokeOpacity="0.5" strokeWidth="2.2" strokeLinecap="round" strokeDasharray="1.5 12">
          <path d="M120 270 C 360 210 560 320 760 256 S 1160 210 1330 282" />
        </g>
        <g fill="#ffd9a8" fillOpacity="0.42">
          <g transform="translate(120,270)"><path d="M0 0 C-7 -10 -7 -18 0 -18 C7 -18 7 -10 0 0 Z" /></g>
          <g transform="translate(760,256)"><path d="M0 0 C-7 -10 -7 -18 0 -18 C7 -18 7 -10 0 0 Z" /></g>
          <g transform="translate(1330,282)"><path d="M0 0 C-7 -10 -7 -18 0 -18 C7 -18 7 -10 0 0 Z" /></g>
        </g>
      </svg>
    </div>

    <div className="journey-india__wrap">
      <span className="journey-india__eyebrow">Made for Indian journeys</span>
      <h2 className="journey-india__title" id="journey-india-heading">
        Wherever the road leads, <span>we travel it with you</span>
      </h2>
      <p className="journey-india__lead">
        Pilgrimage towns, hill escapes, city runs and airport dashes. Whatever the reason
        you are going, a clean car and a driver you can trust are ready, at one fixed fare.
      </p>

      <div className="journey-india__grid">
        {JOURNEYS.map((j) => (
          <Link className="ji-card" to={j.to} key={j.title}>
            <span className="ji-card__ic">{j.icon}</span>
            <h3 className="ji-card__title">{j.title} <Arrow /></h3>
            <p className="ji-card__text">{j.text}</p>
          </Link>
        ))}
      </div>
    </div>
  </section>
)

export default JourneyIndia
